import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { find, maxBy, minBy, reduce } from 'lodash'
import { getDate } from '../../../utils/DateUtil'
import DtoAnalysis from '../../dto/DtoAnalysis'
import { connect } from 'react-redux'
import DtoUnit from '../../../referential/dto/DtoUnit'
import DtoRemark from '../../../referential/dto/DtoRemark'
import i18n from 'simple-react-i18n'

class KeyFiguresParmeters extends Component {
	getEndingDate = (list) => {
		return this.getDateByMinOrMax(list, maxBy)
	}
	getBeginningDate = (list) => {
		return this.getDateByMinOrMax(list, minBy)
	}
	getDateByMinOrMax = (list, filter) => {
		let result = filter(list, (o) => {
			return o.analysisDate
		})
		if (result) {
			return getDate(result.analysisDate)
		}
		return ''
	}

	getValue(analyse) {
		if (analyse.unit) {
			const unit = find(this.props.units, (o) => {
				return o.id == analyse.unit
			})
			if (unit && unit.symbol) {
				return analyse.result + ' ' + unit.symbol
			}
			return analyse.result
		}
		return analyse.result
	}

	getMeasuresByMinOrMax = (list, filter) => {
		let result = filter(list, (o) => {
			return o.result
		})
		if (result) {
			return result
		}
		return ''
	}

	getMeasure = (filter) => {
		const maxMeasure = this.getMeasuresByMinOrMax(this.props.analysis, filter)
		if (maxMeasure) {
			return this.getValue(maxMeasure) + ' (' + getDate(maxMeasure.analysisDate) + ')'
		}
		return ''
	}

	getRemark = () => {
		const reduceRemark = reduce(this.props.analysis, (result, value) => {
			if (value.remarkCode) {
				if (result[value.remarkCode]) {
					result[value.remarkCode] = result[value.remarkCode] + 1
				} else {
					result[value.remarkCode] = 1
				}
			}
			return result
		}, {})

		if (Object.keys(reduceRemark).length > 0) {
			return Object.keys(reduceRemark).map((remark) => {
				if (this.props.remarks.length > 0) {
					const remarkRef = find(this.props.remarks, (o) => {
						return o.id == remark
					})
					return (
						<div className='col l12'><span>{ remarkRef.mnemonique } : { reduceRemark[remark] }</span></div>
					)
				}
				return (
					<div className='col l12'><span>{ remark } : { reduceRemark[remark] }</span></div>
				)
			})
		}
		return (
			<div className='col l12'><span>{ i18n.warning.noCodeNoticed }</span></div>
		)
	}

	render() {
		const min = this.getMeasure(minBy)
		const max = this.getMeasure(maxBy)
		return (
			<div>
				<div className='row no-margin'>
					<div className='col l12'><span>{ i18n.historical } : { this.getBeginningDate(this.props.analysis) } -
						{ this.getEndingDate(this.props.analysis) }</span>
					</div>
					<div className='col l12'><span>{ i18n.min } : { min }</span></div>
					<div className='col l12'><span>{ i18n.max } : { max }</span></div>
					{ this.getRemark() }
				</div>
			</div>
		)
	}
}

KeyFiguresParmeters.propTypes = {
	analysis: PropTypes.arrayOf(PropTypes.objectOf(DtoAnalysis)),
	units: PropTypes.arrayOf(PropTypes.objectOf(DtoUnit)),
	remarks: PropTypes.arrayOf(PropTypes.objectOf(DtoRemark))
}

KeyFiguresParmeters.defaultProps = {
	analysis: [],
	units: [],
	remarks: []
}

const mapStateToProps = store => {
	return {
		units: store.ReferentialReducer.units,
		remarks: store.ReferentialReducer.remarks
	}
}

export default connect(mapStateToProps)(KeyFiguresParmeters)



// WEBPACK FOOTER //
// ./src/station/components/qualitometer/KeyFiguresParmeters.js